import React from 'react'
import ToolbarButton from '../Page/ToolbarButton'
import Typography from '@material-ui/core/Typography'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	pageText: {
		alignSelf: "center"
	}
}

const Pagination = ({ page, maxPage, onPrevious, onNext, classes }) => (
	<React.Fragment>
		<ToolbarButton
			title = "Föregående sida"
			icon = {<NavigateBeforeIcon />}
			onClick = {onPrevious}
			disabled = { page === 1 }
		/>
		<Typography variant="caption" className={classes.pageText} component="div">
			{page} av {maxPage}
		</Typography>
		<ToolbarButton
			title = "Nästa sida"
			icon = {<NavigateNextIcon />}
			onClick = {onNext}
			disabled = { page === maxPage }
		/>
	</React.Fragment>
)

export default withStyles(styles)(Pagination)



// WEBPACK FOOTER //
// ./src/components/Selection/Pagination.js